<template>
    <client-page>
        <sub-visual sh="Distributor in Korea" tabActive="Dupont Kalrez®" bg="/images/sub/visual/sv3.png"> </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container class="mb-lg-42">
                <h2 class="page-tit mb-18 mb-lg-24">
                    <v-img max-width="470" src="/images/logos/kalrez.png" alt="Dupont Kalrez" class="mx-auto" />
                    <!-- Dupont Kalrez® -->
                </h2>
                <h3 class="tit text-center primary--text">Dupont Kalrez® 공식 대리점</h3>
            </v-container>

            <sub-bg-image src="/images/sub/distributor/kalrez/kalrez-top-img.png" className="h-lg-280px">
                <h3 class="tit font-weight-semibold mb-8 mb-md-50 mb-lg-100">
                    DUPONT은 약 200년 이상의 <br />
                    전통을 가진 미국 화학회사 입니다.
                </h3>
                <p class="page-text color-grey-51 mb-2 mb-lg-10">
                    Kalrez® 부품은 항공우주 및 화학 가공에서부터 칩 제조, 석유 및 가스 추출업 <br class="d-none d-md-block" />
                    등 연구를 거듭해 개발한 Metal Sleeve는 10μm 정도의 초박육 설계로, <br class="d-none d-md-block" />
                    이음매가 없는 금속 가공하여, 고성능의 OA 기기에는 꼭 필요한 부품으로 <br class="d-none d-md-block" />
                    큰 점유율을 차지하고 있습니다.
                </p>
                <p class="page-text color-grey-51">
                    환경산업과 의료산업 등 향후 성장이 기대되는 분야로 시야를 넓혀 <br class="d-none d-md-block" />
                    독자적인 기술로 확실한 가치와 상품을 제공해 나갈 것입니다.
                </p>
            </sub-bg-image>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="특장점">
                    <v-row>
                        <icon-line-box icon="/images/sub/distributor/kalrez/kalrez-icon1.png" iconWidth="50" num="01">
                            다양한 화합물로 이루어진 Kalrez® 부품은 다른 화학 물질과 <br class="d-none d-lg-block" />
                            온도에서 견딜 수 있는 특성을 지녀 내화학성에 뛰어납니다.
                        </icon-line-box>

                        <icon-line-box icon="/images/sub/distributor/kalrez/kalrez-icon2.png" iconWidth="38" num="02">내열성이 강하여 금속, 세라믹 및 기타 폴리머를 대체할 수 있는 제품이며 다양한 용도에서 비용 절감과 응용에 최적화된 제품입니다.</icon-line-box>

                        <icon-line-box icon="/images/sub/distributor/kalrez/kalrez-icon3.png" iconWidth="50" num="03">
                            Kalrez® 제품은 인증 받은 제품으로써 씰 고장 가능성을 줄여 <br class="d-none d-lg-block" />
                            급속 가스 감압에 엄격한 요구 조건을 충족시켰습니다.
                        </icon-line-box>

                        <icon-line-box icon="/images/sub/distributor/kalrez/kalrez-icon4.png" iconWidth="50" num="04">
                            웨이퍼 수율에는 순도가 매우 중요한 만큼 특수 제작된 Kalrez® <br class="d-none d-lg-block" />
                            FFKM 씰은 입자, 가스 배출 및 추출물로 인한 웨이퍼 오염을 <br class="d-none d-lg-block" />
                            줄입니다.
                        </icon-line-box>
                    </v-row>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="Kalrez®">
                    <p class="page-text color-grey-51 mb-30 mb-lg-52">
                        Kalrez®부품은 Dupont Elastomers 社에서 원재료 폴리머에서 고무 성형까지 일관되게 하고 있는 Perfluoro Elastomer <br class="d-none d-lg-block" />
                        부품의 등록 상표이며, 테프론을 고무화 한 제품입니다. 가혹한 환경에서도 내성이 강한 고기능성 고무 재료이며, 정밀도와 <br class="d-none d-lg-block" />
                        고성능을 요구하는 모든 산업 분야에서 사용되고 있습니다.
                    </p>
                    <v-row no-gutters>
                        <v-col cols="12" md="4">
                            <table class="client-table client-table-lg w-100 border-md-end">
                                <colgroup>
                                    <col style="width: 25%" />
                                    <col style="width: 75%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Plasma Process</div>
                                        </th>
                                        <th>
                                            <div class="table-inner">Properties ( 특성 )</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 9600</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· Fluorine 및 Oxygen 계열의 plasma 환경에 대한 저항성이 뛰어난 제품</p>
                                                    <p class="dot-txt-rounded">· Kalrez® 9500의 장점에 Compression Set 특성을 개선 하였고,CVD/ALD 공정에 특화됨</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 9500</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· 높은 온도에 대해 뛰어난 내열성을 가진 제품</p>
                                                    <p class="dot-txt-rounded">· Sticking 및 Outgassing 부분을 개선함</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 9300</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· 물리적, 화학적 플라즈마에 대한 균형 잡힌 저항성을 가진 제품</p>
                                                    <p class="dot-txt-rounded">· 금속 Particle 발생 최소화</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 9100</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· 플라즈마로 인한 Particle 발생 및 Erosion을 최소화한 제품</p>
                                                    <p class="dot-txt-rounded">· 건식 공정에서 우수한 저항성을 가짐</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 6005</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· Etch, Ashing, Stripping 공정 등에 특화된 제품</p>
                                                    <p class="dot-txt-rounded">· 높은 온도에서 낮은 Sticking 특성을 가짐</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 8002</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· 산소 및 불소계 플라즈마로 인한 Particle 발생을 최소화한 제품</p>
                                                    <p class="dot-txt-rounded">· 낮은 영구 압축줄음율을 가짐</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 8085</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· NF3 플라즈마 환경에서 Particle 발생을 최소화한 제품</p>
                                                    <p class="dot-txt-rounded">· 높은 기계적 강도를 갖도록 고안됨</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-col>
                        <v-col cols="12" md="4">
                            <table class="client-table client-table-lg w-100 border-md-end">
                                <colgroup>
                                    <col style="width: 25%" />
                                    <col style="width: 75%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Thermal Process</div>
                                        </th>
                                        <th>
                                            <div class="table-inner">Properties ( 특성 )</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 8900</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· 높은 온도에 대해 뛰어난 내열성을 가진 제품</p>
                                                    <p class="dot-txt-rounded">· Sticking 및 Outgassing 부분을 개선함</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 7075</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· 높은 온도에서 기계적 특성을 유지하는 제품</p>
                                                    <p class="dot-txt-rounded">· 낮은 영구압축줄음률을 가짐</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 8475</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· 적외선 흡수를 감소시켜 Seal 온도 상승을 낮춘 제품</p>
                                                    <p class="dot-txt-rounded">· Lamp Anneal, RTP Sealing 등에 특화</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 8575</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded mb-2 mb-lg-6">· 탄성 회복력을 향상시키고 Outgassing을 개선한 제품</p>
                                                    <p class="dot-txt-rounded">· CIF3와 같은 염소계 세정 가스에 대한저항성을 개선</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-col>
                        <v-col cols="12" md="4">
                            <table class="client-table client-table--last client-table-lg w-100">
                                <colgroup>
                                    <col style="width: 25%" />
                                    <col style="width: 75%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Wet Process</div>
                                        </th>
                                        <th>
                                            <div class="table-inner">Properties ( 특성 )</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 6375</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded">· 모든 습식 화학 공정에 사용</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="table-inner">Kalrez® 4079</div>
                                        </th>
                                        <td>
                                            <div class="table-inner left">
                                                <div class="px-xl-16">
                                                    <p class="dot-txt-rounded">· 건식 및 습식 공정에서 범용적으로 사용</p>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-col>
                    </v-row>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="Kalrez® 재질 특성">
                    <table class="client-table client-table-lg w-100 word-break-word word-sm-keep-all">
                        <thead>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">Kalrez® Grade</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Kalrez® Remark</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Color</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Image</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Hardness</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Max Service Temp. ℃(℉)</div>
                                </th>
                                <th>
                                    <div class="table-inner">Compression Set at 70hr204℃, %</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">9600</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>고온 진공 환경에서 불소와 산소 플라즈마 라디칼에 노출되는 경우 씰링은 플라즈마 공격으로 인한 <span class="color-point font-weight-bold">침식 속도와 무게 감소</span>가 극히 <span class="color-point font-weight-bold">낮으며</span> 암모니아, 오존 및 수증기에 대한 <span class="color-point font-weight-bold">우수한 화학 저항성</span>을 제공</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Olive- Green</p>
                                        <v-avatar color="#89AC23" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-9600.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>70</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>315 (599)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>15</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">9500</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>SACVD, FCVD, PECVD 공정 오존, 암모니아 및 수증기가 발생되는 <span class="color-point font-weight-bold">증착 공정</span>에 적합</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Tan</p>
                                        <v-avatar color="#FABA86" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-9500.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>76</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>310 (590)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>20</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">9300</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>Dielectric Etch (산화물 에칭)에 사용하며 산소와 불소 기반의 플라즈마 및 내화학성 우수</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Brown</p>
                                        <v-avatar color="#800000" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-9300.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>77</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>300 (572)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>25</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">9100</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>ALD, HDPCVD, Conductor Etch 에 적합 <span class="color-point font-weight-bold">플라즈마 환경</span>에서 <span class="color-point font-weight-bold">낮은 용출</span> 및 초 저 입자 생성</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Amber</p>
                                        <v-avatar color="#FFCC00" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-9100.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>77</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>300 (572)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>18</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">8002</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>Ash / Strip 공정에 사용하기 위한 <span class="color-point font-weight-bold">투명 제품</span>이며 무기물질첨가제가 포함된 제품 대비산소 및 불소 기반의 플라즈마에서 <span class="color-point font-weight-bold">우수한 Crack 저항</span>과초 저 미세 입자 생성</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Clear</p>
                                        <v-avatar color="#D9D9D9" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-8002.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>69</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>275 (527)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>12</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">8705</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>플라즈마에서 방출되는 고 에너지 자외선으로 인한 고농도의 유해 산소 자유 라디칼에대한 내화학성과 고온 진공에서도 우수한씰링 기능을 보여줌</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Black</p>
                                        <v-avatar color="#000" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-8705.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>77</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>327 (621)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>24</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">8900</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>산화, ALD, LPCVD와 같은 고온에서 <span class="color-point font-weight-bold">물리적 특성</span>을 우수하게 <span class="color-point font-weight-bold">유지</span>하며, 뛰어난 강도를 지니고 있어 <span class="color-point font-weight-bold">정적 및 동적 실링</span> 분야에 모두 <span class="color-point font-weight-bold">적합</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Black</p>
                                        <v-avatar color="#000" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-8900.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>76</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>325 (617)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>20</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">8575</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>산화, Lamp Anneal, RTP와 같은 <span class="color-point font-weight-bold">고온</span>에서 <span class="color-point font-weight-bold">매우 낮은 IR</span>(적외선) <span class="color-point font-weight-bold">흡수</span> 및 아웃 가싱 특성을 나타냄</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">White</p>
                                        <v-avatar color="#fff" size="24" class="mt-6 mt-md-8 border border-2" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-8575.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>63</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>300 (572)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>25</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">7075 UP</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>Metal, CVD와 같은 <span class="color-point font-weight-bold">뛰어난 열 안정성</span> (327℃), Kalrez®7075 UP으로 만든 제품은 초 순수 후 처리 가능</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Black</p>
                                        <v-avatar color="#000" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-7075-up.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>75</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>327 (621)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>13</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">9500</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>높은 열 안정성, 매우 낮은 배출가스 및 우수한 강성을 지니며 <span class="color-point font-weight-bold">정적 및 동적 씰링</span> 분야에 모두 <span class="color-point font-weight-bold">적합</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Tan</p>
                                        <v-avatar color="#FABA86" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-9500.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>76</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>310 (590)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>18</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner">9600</div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>높은 온도 조건에서의 뛰어난 압축 탄력성과 초 저 진공에서의 우수한 저 가스성으로 인해 순도가 매우 중요한 분야에 적합</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="w-100">Olive- Green</p>
                                        <v-avatar color="#89AC23" size="24" class="mt-6 mt-md-8" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <v-img src="/images/sub/distributor/kalrez/kalrez-9600-2.png" class="w-40px w-md-130px" />
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>70</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>315 (599)</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>12</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="Kalrez® 공정별 추천 재질" class="mb-40 mb-lg-60">
                    <h5 class="font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium">Plasma Process</h5>
                    <table class="client-table client-table-lg w-100 word-break-word word-sm-keep-all mb-40 mb-lg-60">
                        <thead>
                            <tr>
                                <th class="border-end w-md-17">
                                    <div class="table-inner">Process Type</div>
                                </th>
                                <th class="border-end w-md-26">
                                    <div class="table-inner">Process Remark</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Maximum Service Temperature</div>
                                </th>
                                <th class="border-end w-md-28">
                                    <div class="table-inner">Typical Chemistries</div>
                                </th>
                                <th>
                                    <div class="table-inner">Suggested Product</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>HDPCVD</p>
                                        <span class="font-size-10 font-size-md-12 line-height-13 font-weight-regular grey--text mt-6 mt-md-8">High-Density Plasma <br class="d-none d-md-block" />Chemical Vapor Deposition</span>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>고밀도 플라즈마 화학 기상 증착법</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>250℃ ~ <span class="font-weight-bold">300℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>TMS를 적용하여 웨이퍼 표면의 <br class="d-none d-md-block" /><span class="color-point font-weight-bold">유기 잔류물</span>을 <span class="color-point font-weight-bold">용해</span>시켜 제거하는 용도</p>
                                        <span class="font-size-10 font-size-md-12 line-height-13 font-weight-regular grey--text mt-6 mt-md-8">DEMS, TEOS, SiH₄, SiF₄, <br class="d-none d-md-block" />NH₃, O₂, N₂O, C₄F₈, NF₃</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 9100 / 9500</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>PECVD / PEALD</p>
                                        <span class="font-size-10 font-size-md-12 line-height-13 font-weight-regular grey--text mt-6 mt-md-8">Plasma-Enhanced <br class="d-none d-md-block" />Atomic Layer Deposition</span>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>플라즈마 증강 원자 층 증착</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>275℃ ~ <span class="font-weight-bold">310℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>TMS, DEMS, TEOS 사용 TMS, 전기화학적 질량 분석법, SiO₂중착 사용</p>
                                        <span class="font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8">SiH₄, SiF₄, NH₃, O₂, N₂O, C₄F₈, NF₃</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 9600</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">
                                            PECVD<br />
                                            Curing Process
                                        </p>
                                        <span class="font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8">Plasma-Enhanced <br class="d-none d-md-block" />Chemical Vapor Deposition</span>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>플라즈마 증강 화학 기상 증착 기술을 활용한 코팅 및 경화 공정</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>150℃ ~ <span class="font-weight-bold">200℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>O₃  + UV Light</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 8705 / 9500</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">SACVD / FCVD</p>
                                        <span class="font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8">Sub-Atmospheric Chemical Vapor Deposition</span>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>부분 진공 환경에서 화학 기상 증착 기술을 활용한 층 증착 기술</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>280℃ ~ <span class="font-weight-bold">300℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>
                                            TEP<br />
                                            금속 이온을 생성하기 위한 환원제
                                        </p>
                                        <span class="font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8">NH₃, O₃, NF₃</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 9500 / 9600</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">Conductor Etch</p>
                                        <span class="font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8">Poly / Metal</span>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>전도체 층을 제거하는 기술</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>150℃ ~ <span class="font-weight-bold">225℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>CF₄, CHF₃, HBr, BCl₃, CCl₄, Cl₂, NF₃</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 9100 / 9300</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">Dielectric Etch</p>
                                        <span class="font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8">Oxide</span>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>산화물과 같은 절연체 층을 제거하는 기술</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>100℃ ~ <span class="font-weight-bold">180℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>CF₄, C₃F₈, CHF₃, SF₆, O₂, H₂</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 9300</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">Ash / Strip</p>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left">
                                        <p>Ash 층 표면의 유기물을 제거하는 공정 / Strip 공정은 산화물을 제거하기 위한 공정</p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>180℃ ~ <span class="font-weight-bold">250℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>CF₄, CHF₃, O₂, NH₃, Water Vapor, H₂, Forming Gas</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 9300 / 8002</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <h5 class="font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium">Thermal Process</h5>
                    <table class="client-table client-table-lg w-100 word-break-word word-sm-keep-all mb-40 mb-lg-60">
                        <thead>
                            <tr>
                                <th class="border-end w-md-17">
                                    <div class="table-inner">Process Type</div>
                                </th>
                                <th class="border-end w-md-26">
                                    <div class="table-inner">Process Remark</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Maximum Service Temperature</div>
                                </th>
                                <th class="border-end w-md-28">
                                    <div class="table-inner">Typical Chemistries</div>
                                </th>
                                <th>
                                    <div class="table-inner">Suggested Product</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">
                                            ALD, LPCVD, <br class="d-none d-md-block" />
                                            Metal CVD
                                        </p>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left flex-wrap line-height-135">
                                        <div>
                                            <div>원자층 증착법  (ALD)</div>
                                            <p class="font-size-10 font-size-md-12 font-weight-regular grey--text">기체 전자로부터 층을 쌓아 올리는 방식</p>
                                        </div>
                                        <div class="mt-6 mt-md-8">
                                            <div>저압 화학 기상 증착 (LPCVD)</div>
                                            <p class="font-size-10 font-size-md-12 font-weight-regular grey--text">
                                                가스 혼합물을 진공 상태에서 고온으로 <br class="d-none d-md-block" />
                                                반응시켜 기판 표면에 고체 필름을 생성
                                            </p>
                                        </div>
                                        <div class="mt-6 mt-md-8">
                                            <div>금속 증착법 (Metal CVD)</div>
                                            <p class="font-size-10 font-size-md-12 font-weight-regular grey--text">
                                                가스 혼합물을 진공 상태에서 고온으로 <br class="d-none d-md-block" />
                                                반응시켜 기판 표면에 고체 필름을 생성
                                            </p>
                                        </div>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>250℃ ~ <span class="font-weight-bold">300℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>
                                            WF₆, TiCl₄, HF, SiF₄, F₂, <br class="d-none d-md-block" />
                                            N₂O Vapor, Cl₂, ClF₃
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 7075 UP / 8900</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">
                                            Oxidation, <br class="d-none d-md-block" />
                                            Nitridation, <br class="d-none d-md-block" />
                                            Diffusion
                                        </p>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left flex-wrap line-height-135">
                                        <div>
                                            <div>산화 공정 (Oxidation)</div>
                                            <p class="font-size-10 font-size-md-12 font-weight-regular grey--text">산소 원자를 삽입하여 산화막을 형성하는 과정</p>
                                        </div>
                                        <div class="mt-6 mt-md-8">
                                            <div>질화 공정 (Niridation)</div>
                                            <p class="font-size-10 font-size-md-12 font-weight-regular grey--text">질소를 삽입하여 질화막을 형성하는 과정</p>
                                        </div>
                                        <div class="mt-6 mt-md-8">
                                            <div>확산 공정(Diffusion)</div>
                                            <p class="font-size-10 font-size-md-12 font-weight-regular grey--text">불순물을 반도체 소자의 표면에서 내부로 이동시키는 과정</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>250℃ ~ <span class="font-weight-bold">300℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>
                                            O₂, N₂, N₂O Vapor, <br class="d-none d-md-block" />
                                            Cl₂, O₃, HCl
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 7075 UP / 8900</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">
                                            Lamp Anneal, <br class="d-none d-md-block" />
                                            RTP
                                        </p>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left flex-wrap line-height-135">
                                        <p><span class="color-point font-weight-bold">빛</span>을 쬐어 <span class="color-point font-weight-bold">고온의 가열</span>로 인해 물질 구조의 결정성을 증가, <span class="color-point font-weight-bold">1000℃ 이상</span> 유지하여 반도체 <span class="color-point font-weight-bold">소자의 특성을 개선</span></p>
                                        <span class="font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8">(불순물 확산, 불순물 활성화, 산화, 질화) </span>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>250℃ ~ <span class="font-weight-bold">275℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>
                                            Infrared Light, <br class="d-none d-md-block" />
                                            N₂O Vapor, O₂
                                        </p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 8575</p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">
                                            Wafer Surface <br class="d-none d-md-block" />
                                            Preparation
                                        </p>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner left flex-wrap line-height-135">
                                        <p>반도체 <span class="color-point font-weight-bold">웨이퍼 표면</span>을 <span class="color-point font-weight-bold">깨끗</span>하고 매끄럽게 만들어 다음 공정에 적용할 수 있도록 하는 과정</p>
                                        <span class="font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8">(Etching, Cleaning, CMP)</span>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>250℃ ~ <span class="font-weight-bold">275℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p>NH₃, H₂, F₂, NF₃, HF</p>
                                    </div>
                                </td>
                                <td>
                                    <div class="table-inner">
                                        <p>Kalrez® 9500 / 9600</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <h5 class="font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium">Wet Process</h5>
                    <table class="client-table client-table-lg w-100 word-break-word word-sm-keep-all">
                        <thead>
                            <tr>
                                <th class="border-end w-md-17">
                                    <div class="table-inner">Process Type</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Maximum Service Temperature</div>
                                </th>
                                <th class="border-end w-md-28">
                                    <div class="table-inner">Typical Chemistries</div>
                                </th>
                                <th>
                                    <div class="table-inner">Suggested Product</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">Wafer Preparation</p>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>70℃ ~ <span class="font-weight-bold">125℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner left flex-wrap line-height-135">
                                        <div class="w-100">
                                            <div>UPW</div>
                                            <p class="font-size-10 font-size-md-12 grey--text">(Ultra-Pure Water) 초순수 물</p>
                                        </div>
                                        <div class="w-100 mt-6 mt-md-8">
                                            <div>Piranha</div>
                                            <p class="font-size-10 font-size-md-12 grey--text">황산과 과산화수소의 혼합물1</p>
                                        </div>
                                        <div class="w-100 mt-6 mt-md-8">
                                            <div>SC-1, SC-2, O₃</div>
                                        </div>
                                        <div class="w-100 mt-6 mt-md-8">
                                            <div>EKC fluids</div>
                                            <p class="font-size-10 font-size-md-12 grey--text">(Electronic Grade Chemicals) 고순도 화학 액체</p>
                                        </div>
                                    </div>
                                </td>
                                <td rowspan="4">
                                    <div class="table-inner left flex-wrap line-height-135">
                                        <div class="w-100 font-weight-bold">Kalrez® W240UP</div>
                                        <p class="w-100 mt-6 mt-md-8">
                                            <span class="color-point font-weight-bold">화학적 저항성</span>이 필요한 <br class="d-none d-md-block" />
                                            <span class="color-point font-weight-bold">필터, 밸브, 펌프</span> 등에 쓰이는 오링으로 <br class="d-none d-md-block" />
                                            색상은 <span class="color-point font-weight-bold">검은색</span>을 나타냅니다.
                                        </p>
                                        <p class="w-100 mt-6 mt-md-8">
                                            <span class="color-point font-weight-bold">산/알칼리</span>에 대한 <span class="color-point font-weight-bold">저항성,</span> <br class="d-none d-md-block" />
                                            고 <span class="color-point font-weight-bold">습윤 공정용</span> 제품으로 선호되며
                                        </p>
                                        <p class="w-100 mt-6 mt-md-8">
                                            제조 후, 초순수 <span class="color-point font-weight-bold">세정 공정</span>을 통하여 <br class="d-none d-md-block" />
                                            제품에 <span class="color-point font-weight-bold">Particle</span>이 <span class="color-point font-weight-bold">거의 없습니다.</span>
                                        </p>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">Etching</p>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>70℃ ~ <span class="font-weight-bold">95℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner left flex-wrap line-height-135">
                                        <p>HNO₃, HF₂, H₂O, H₃PO₄, NH₄OH</p>
                                        <span class="font-size-10 font-size-md-12 line-height-135 font-weight-regular grey--text mt-6 mt-md-8">[ 질산, 이중 염산, 물, 인산, 수산화 암모늄 ]</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">Stripping</p>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>70℃ ~ <span class="font-weight-bold">125℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner left flex-wrap line-height-135">
                                        <div class="w-100">
                                            <div>NMP</div>
                                            <p class="font-size-10 font-size-md-12 grey--text">(N-Methyl-2-Pyrrolidone) 산화막 및 layer 제거 공정에 사용</p>
                                        </div>
                                        <div class="w-100 mt-6 mt-md-8">
                                            <div>Alkanolamine</div>
                                            <p class="font-size-10 font-size-md-12 grey--text">에칭, 산화 제거, 세정에 사용</p>
                                        </div>
                                        <div class="w-100 mt-6 mt-md-8">
                                            <div>Hydroxylamine</div>
                                            <p class="font-size-10 font-size-md-12 grey--text">전자 빔 증착 공정 후, 표면에 남은 유기 잔여물 제거에 사용</p>
                                        </div>
                                        <div class="w-100 mt-6 mt-md-8">
                                            <div>Acetone / IPA</div>
                                            <p class="font-size-10 font-size-md-12 grey--text">유/무기 오염 물질을 제거</p>
                                        </div>
                                        <div class="w-100 mt-6 mt-md-8">
                                            <div>EKC 265</div>
                                            <p class="font-size-10 font-size-md-12 grey--text">(Electronic Grade Chemicals) 부식 및 오염 제거를 위해 사용되는 알칼리성 용액</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="border-end">
                                    <div class="table-inner flex-wrap">
                                        <p class="line-height-12 w-100">Copper Plating</p>
                                    </div>
                                </th>
                                <td class="border-end">
                                    <div class="table-inner">
                                        <p>70℃ ~ <span class="font-weight-bold">125℃</span></p>
                                    </div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner left flex-wrap line-height-135">
                                        <div class="w-100">
                                            <div>CuSO₄ Solution, H₂SO₄</div>
                                            <p class="font-size-10 font-size-md-12 grey--text">[ 구리 황산염 용액 – Etching Fluid, 웨이퍼 표면 산화물 제거]</p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="Kalrez® Groove">
                    <p class="page-text color-grey-51 mb-30 mb-lg-52">새로운 장비를 개발하거나 Viton O-ring에서 Kalrez O-ring으로 변경했을 때, 문제가 발생했다면 O-ring Groove는 검토 해야 할 대상 중 하나입니다. Kalrez는 Viton보다 높은 열팽창 특성을 가지기 때문에 이를 고려하지 않고 Groove 변경 없이 고온에서 사용할 경우 Crack 또는 Extrusion 현상이 발생할 수 있습니다.</p>
                    <h5 class="font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium">Rectangular Groove for Static Application</h5>
                    <table class="client-table client-table-lg w-100 word-break-word word-sm-keep-all mb-40 mb-lg-60">
                        <thead>
                            <tr>
                                <th class="border-end w-md-80px">
                                    <div class="table-inner">Code Name</div>
                                </th>
                                <th class="border-end w-md-220px">
                                    <div class="table-inner">Product Drawing</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Code No.</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">CSD</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Temp.(℃)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Width(G)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Depth(H)</div>
                                </th>
                                <th>
                                    <div class="table-inner">Radius(R)</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th rowspan="6" class="border-end">
                                    <div class="table-inner">AS568A</div>
                                </th>
                                <td rowspan="6" class="border-end">
                                    <div class="table-inner">
                                        <v-img max-width="198" src="/images/sub/distributor/kalrez/groove-rectangular.png" class="w-100px w-md-198px" />
                                    </div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">102 ~ 178</div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">2.62± <span class="font-size-10 font-size-md-12">0.08</span></div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">≤ 180</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">3.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">2.00</div>
                                </td>
                                <td>
                                    <div class="table-inner">0.40</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="border-end">
                                    <div class="table-inner">≤ 250</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">3.55</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">2.00</div>
                                </td>
                                <td>
                                    <div class="table-inner">0.40</div>
                                </td>
                            </tr>
                            <tr>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">201 ~ 284</div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">3.53±<span class="font-size-10 font-size-md-12">0.10</span></div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">≤ 180</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.40</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">2.85</div>
                                </td>
                                <td>
                                    <div class="table-inner">0.60</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="border-end">
                                    <div class="table-inner">≤ 250</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.80</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">2.85</div>
                                </td>
                                <td>
                                    <div class="table-inner">0.60</div>
                                </td>
                            </tr>
                            <tr>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">309 ~ 395</div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">5.33±<span class="font-size-10 font-size-md-12">0.13</span></div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">≤ 180</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">6.50</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.30</div>
                                </td>
                                <td>
                                    <div class="table-inner">0.90</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="border-end">
                                    <div class="table-inner">≤ 250</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">7.15</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.30</div>
                                </td>
                                <td>
                                    <div class="table-inner">0.90</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <h5 class="font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium">Dovetail Groove for Application</h5>
                    <table class="client-table client-table-lg w-100 word-break-word word-sm-keep-all">
                        <thead>
                            <tr>
                                <th class="border-end w-md-80px">
                                    <div class="table-inner">Code Name</div>
                                </th>
                                <th class="border-end w-md-220px">
                                    <div class="table-inner">Product Drawing</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Code No.</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">CSD</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Temp.(℃)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Top Width to Sharps (G`)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Top Width (G)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Depth (H)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Top Radius (R1)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Bottom Radius (R1)</div>
                                </th>
                                <th>
                                    <div class="table-inner">Side Wall Angle</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th rowspan="6" class="border-end">
                                    <div class="table-inner">AS568A</div>
                                </th>
                                <td rowspan="6" class="border-end">
                                    <div class="table-inner">
                                        <v-img max-width="198" src="/images/sub/distributor/kalrez/groove-dovetail.png" class="w-100px w-md-198px" />
                                    </div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">201~284</div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">3.53±<span class="font-size-10 font-size-md-12">0.10</span></div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">≤ 180</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">2.98</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">3.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">2.85</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.80</div>
                                </td>
                                <td rowspan="4">
                                    <div class="table-inner">0.80</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="border-end">
                                    <div class="table-inner">≤ 250</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">3.53</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">3.75</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">2.85</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.80</div>
                                </td>
                            </tr>
                            <tr>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">201~284</div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">5.33±<span class="font-size-10 font-size-md-12">0.13</span></div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">≤ 180</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.47</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.90</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.30</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.40</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.80</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="border-end">
                                    <div class="table-inner">≤ 250</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.77</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">5.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.30</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.40</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.80</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="font-size-12 font-size-md-14 mt-8 mt-lg-10 mb-40 mb-lg-60">*Dovetail Design을 적용한 <span class="color-point font-weight-bold">Dynamic</span> 부위면서 <span class="color-point font-weight-bold">250℃</span> 이상인 공정 조건에 적용 시 Static 을 적용한 <span class="color-point font-weight-bold">수명</span>보다 <span class="color-point font-weight-bold">줄어들 수 있음</span></p>

                    <h5 class="font-size-18 font-size-md-22 mb-6 mb-md-10 font-weight-medium">Half-Dovetail Groove for Static Application</h5>
                    <table class="client-table client-table-lg w-100 word-break-word word-sm-keep-all">
                        <thead>
                            <tr>
                                <th class="border-end w-md-80px">
                                    <div class="table-inner">Code Name</div>
                                </th>
                                <th class="border-end w-md-220px">
                                    <div class="table-inner">Product Drawing</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Code No.</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">CSD</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Temp.(℃)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Top Width to Sharps (G`)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Top Width (G)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Depth (H)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Top Radius (R1)</div>
                                </th>
                                <th class="border-end">
                                    <div class="table-inner">Bottom Radius (R1)</div>
                                </th>
                                <th>
                                    <div class="table-inner">Side Wall Angle</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th rowspan="6" class="border-end">
                                    <div class="table-inner">AS568A</div>
                                </th>
                                <td rowspan="6" class="border-end">
                                    <div class="table-inner">
                                        <v-img max-width="198" src="/images/sub/distributor/kalrez/groove-half-dovetail.png" class="w-100px w-md-198px" />
                                    </div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">201~284</div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">3.53±<span class="font-size-10 font-size-md-12">0.10</span></div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">≤ 180</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">3.79</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">3.90</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">2.85</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.80</div>
                                </td>
                                <td rowspan="4">
                                    <div class="table-inner">24°</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="border-end">
                                    <div class="table-inner">≤ 250</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.19</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.30</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">2.85</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.80</div>
                                </td>
                            </tr>
                            <tr>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">201~284</div>
                                </td>
                                <td rowspan="2" class="border-end">
                                    <div class="table-inner">5.33±<span class="font-size-10 font-size-md-12">0.13</span></div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">≤ 180</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">5.49</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">5.60</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.30</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.80</div>
                                </td>
                            </tr>
                            <tr>
                                <td class="border-end">
                                    <div class="table-inner">≤ 250</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">6.09</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">6.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">4.30</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.20</div>
                                </td>
                                <td class="border-end">
                                    <div class="table-inner">0.80</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <sub-line-layout tit="Kalrez® 규격">
                    <p class="page-text color-grey-51 mb-14 mb-lg-16">Kalrez®부품은 AS-568, Metric, JIS, NW 규격에 따른 O-Ring 재고를 보유 중이며 반도체, Display 공정 등 다양한산업에 필요한 재고를 확보하고 있어 고객의 요청 사항에 맞춰 신속한 대응이 가능합니다.</p>
                    <div class="page-text font-weight-medium mb-40 mb-lg-60">표준규격 Kalrez® List를 다운로드 받아 규격 별 리스트를 확인하실 수 있습니다.</div>
                    <v-btn color="primary" href="/assets/document/IST_Dupont Kalrez List-Up.pdf" download>표준 규격 Kalrez® List 다운로드</v-btn>
                </sub-line-layout>
            </v-container>
        </section>

        <section class="sub-section">
            <v-container>
                <inquiry src="/images/sub/distributor/dupont/dupont-img1.png" name="황 명 선" tel="031-765-2268" mail="mshwang@ist-co.kr" fax="031-765-2389" link="https://www.dupont.com/kalrez.html" linkBg="/images/sub/distributor/dupont/dupont-img2.png"> </inquiry>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubLineLayout from "@/components/client/ko/sub/sub-line-layout.vue";
import SubBgImage from "@/components/client/ko/sub/sub-bg-image.vue";
import IconLineBox from "@/components/client/ko/sub/sub-icon-line-box.vue";
import Inquiry from "@/components/client/ko/sub/sub-inquiry.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubLineLayout,
        SubBgImage,
        IconLineBox,
        Inquiry,
    },
};
</script>

<style lang="scss" scoped>
.client-table-lg td .table-inner {
    min-height: initial;
}
@media (min-width: 768px) {
    .w-md-198px {
        width: 198px !important;
    }
}
</style>